import { GET_ANALYTICS_DATA, GET_ANALYTICS_CARD_DATA } from "./actions";

const initialState = {
  loading: true,
  analyticsData: [],
  analyticsCardData: {},
};

const analyticsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ANALYTICS_DATA:
      return {
        ...state,
        loading: false,
        analyticsData: payload,
      };
    case GET_ANALYTICS_CARD_DATA:
      return {
        ...state,
        loading: false,
        analyticsCardData: payload,
      };
    default:
      return state;
  }
};

export default analyticsReducer;
